import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore, setAuthorization } from 'src/helpers/api/apiCore';

// api
import {
    creatResultSet as creatResultSetApi,
    updateResultSet as updateResultSetApi,
    getAllResultSets as getAllResultSetsApi,
    getResultSet as getResultSetApi,
} from './api';

// actions
import { resultSetApiResponseSuccess, resultSetApiResponseError } from './actions';

// constants
import { ResultSetActionTypes } from './constants';

type ResulSetData = {
    payload: any;
    type: string;
};

const api = new APICore();

/**
 * Add Result Set
 * @param {*}
 */
function* addResulSet({ payload, type }: ResulSetData): SagaIterator {
    try {
        const response = yield call(creatResultSetApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                resultSetApiResponseSuccess(
                    ResultSetActionTypes.ADD_RESULT_SET,
                    data,
                    'Result Set has been created.',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while creating Result Set!`;
            if (message) msg = message;
            yield put(resultSetApiResponseSuccess(ResultSetActionTypes.ADD_RESULT_SET, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(resultSetApiResponseError(ResultSetActionTypes.ADD_RESULT_SET, [], error, 404, true, false));
    }
}

/**
 * Edit Result Set
 * @param {*}
 */
function* editResulSet({ payload, type }: ResulSetData): SagaIterator {
    try {
        const response = yield call(updateResultSetApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                resultSetApiResponseSuccess(
                    ResultSetActionTypes.EDIT_RESULT_SET,
                    data,
                    'Result Set Get Updated Successfully',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while edit Result Set!`;
            if (message) msg = message;
            yield put(resultSetApiResponseSuccess(ResultSetActionTypes.EDIT_RESULT_SET, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(resultSetApiResponseError(ResultSetActionTypes.EDIT_RESULT_SET, [], error, 404, true, false));
    }
}

/**
 * Get Result Set
 * @param {*}
 */
function* getResulSet({ payload, type }: ResulSetData): SagaIterator {
    try {
        const response = yield call(getResultSetApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                resultSetApiResponseSuccess(ResultSetActionTypes.GET_RESULT_SET, data, message, code, false, false)
            );
        } else {
            let msg = `An error while getting Result Set!`;
            if (message) msg = message;
            yield put(resultSetApiResponseSuccess(ResultSetActionTypes.GET_RESULT_SET, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(resultSetApiResponseError(ResultSetActionTypes.GET_RESULT_SET, [], error, 404, true, false));
    }
}

/**
 * Get Result Sets
 * @param {*}
 */
function* getResulSets({ payload, type }: ResulSetData): SagaIterator {
    try {
        const response = yield call(getAllResultSetsApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(
                resultSetApiResponseSuccess(
                    ResultSetActionTypes.GET_RESULT_SETS,
                    responseData,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Result Sets Listing!`;
            if (message) msg = message;
            yield put(
                resultSetApiResponseSuccess(ResultSetActionTypes.GET_RESULT_SETS, responseData, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(resultSetApiResponseError(ResultSetActionTypes.GET_RESULT_SETS, [], error, 404, true, false));
    }
}

export function* watchAddResulSet() {
    yield takeEvery(ResultSetActionTypes.ADD_RESULT_SET, addResulSet);
}

export function* watchEditResulSet() {
    yield takeEvery(ResultSetActionTypes.EDIT_RESULT_SET, editResulSet);
}

export function* watchGetResulSet(): any {
    yield takeEvery(ResultSetActionTypes.GET_RESULT_SET, getResulSet);
}

export function* watchGetResulSets(): any {
    yield takeEvery(ResultSetActionTypes.GET_RESULT_SETS, getResulSets);
}

function* resultSetSaga() {
    yield all([fork(watchAddResulSet), fork(watchEditResulSet), fork(watchGetResulSet), fork(watchGetResulSets)]);
}

export default resultSetSaga;
